import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Palette } from '@/themes/themeOverrides/Palette';
import PropTypes from 'prop-types';

const StyledPlaceholderBox = styled(Box)(() => ({
    borderRadius: '4px',
}));

export const NoDataPlaceholder = ({ width = '94px', height = '28px', backgroundColor = Palette.gray.gray75 }) => {
    return (
        <StyledPlaceholderBox
            sx={{
                width,
                height,
                backgroundColor,
            }}
        />
    );
};

NoDataPlaceholder.propTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    backgroundColor: PropTypes.string,
};
